<template>
  <div
    v-if="state === inlineActionConfirmationState.CONFIRM"
    class="
      tw-flex tw-gap-2 tw-h-8 tw-py-0 tw-px-1
      -tw-my-1
      tw-bg-sf-neutral-lighter-1 tw-rounded-lg tw-items-center
    "
  >
    <slot
      name="confirm-action"
      :disabled="disabled"
      :handle-confirm="handleConfirm"
    >
      <SfButtonInverted
        variant="danger"
        class="tw-px-2 tw-text-xs tw-h-6"
        :disabled="disabled"
        @click="handleConfirm"
      >
        <i class="fa fa-trash !tw-text-[10px]"></i>
        {{ I18n.t('common.remove') }}
      </SfButtonInverted>
    </slot>

    <SfButtonInverted
      variant="dark"
      class="tw-h-6 tw-px-2 tw-text-xs"
      :disabled="disabled"
      @click="handleCancel"
    >
      {{ I18n.t('common.cancel') }}
    </SfButtonInverted>
  </div>
  <div v-show="state === inlineActionConfirmationState.FREE">
    <slot :open-confirmation="openConfirmation" />
  </div>
</template>
<script setup lang="ts">
import type { InlineActionConfirmationState } from './constants'

import { ref } from 'vue'

import { inlineActionConfirmationState } from './constants'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { SfButtonInverted } from '@app/shared/vue/components/sf-button'

const I18n = useI18n()

interface Props {
  disabled?: boolean
}

defineProps<Props>()

const state = ref<InlineActionConfirmationState>(
  inlineActionConfirmationState.FREE
)

const emit =
  defineEmits<{
    cancel: []
    confirm: []
  }>()

function openConfirmation() {
  state.value = inlineActionConfirmationState.CONFIRM
}

function handleConfirm() {
  emit('confirm')
  state.value = inlineActionConfirmationState.FREE
}

function handleCancel() {
  emit('cancel')
  state.value = inlineActionConfirmationState.FREE
}
</script>
